//Component to Add new Row. riggers, when the Add New Row button clicked mentioned in the ActionButtons.js
const AddNewRow = ({
  newRow,
  setNewRow,
  handleSaveNewRow,
  handleCancelNewRow,
}) => {
  const editableFields = ['Concept', 'Keywords', 'String'];

  return (
    <tr>
      {/* Renders text boxes for editable fields */}
      {editableFields.map((field) => (
        <td key={field} className="border border-gray-300 p-2">
          <textarea
            type="text"
            rows="5"
            value={newRow[field] || ''}
            onChange={(e) => setNewRow({ ...newRow, [field]: e.target.value })}
            className="w-full h-full p-1 border border-gray-300 rounded"
          />
        </td>
      ))}
    {/* Additionally adds two more buttons (Save, Cancel) to save the added data temporarily/ discard */}
      <td>
        <button
          onClick={handleSaveNewRow}
          className="m-2 mr-0 w-1/6 p-1 shadow-gray-500 shadow-sm bg-green-400 hover:bg-green-500 border-green-500 ring-2 ring-green-500 hover:ring-green-400 text-white rounded"
        >
          Save
        </button>
        <button
          onClick={handleCancelNewRow}
          className="m-2 w-1/6 p-1 shadow-gray-500 shadow-sm bg-red-400 hover:bg-red-500 border-red-500 ring-2 ring-red-500 hover:ring-red-400 text-white rounded"
        >
          Cancel
        </button>
      </td>
    </tr>
  );
};

export default AddNewRow;